export const enums = {
	TYPES: ['Loyalty', 'Employee', 'Neighbour']
};
